import "./App.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
// import HomeScreen from "./screens/HomeScreen";
import ProductView from "./ProductView";
import "bootstrap/dist/css/bootstrap.min.css";
import VCardV from "./VCardV";
import ProductList from "./ProductList";
import ProductForm from "./ProductForm";
import BulkQRCodeGenerator from "./BulkQRCodeGenerator";
import Login from "./Login";
import ProductEdit from "./ProductEdit";
import ProductDeleter from "./ProductDeleter";
import BulkImageUploadForm from "./BulkImageUploadForm";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Layout />} exact>
            {/* <Route path="" element={<HomeScreen />} /> */}
            <Route path="p/:Tag_No" element={<ProductView />} />
            <Route path="login" element={<Login />} />
            <Route path="products/" element={<ProductList />} />
            <Route path="product/images" element={<BulkImageUploadForm />} />
            <Route path="product/edit/:Tag_No" element={<ProductEdit />} />
            <Route path="product/deleter" element={<ProductDeleter />} />
            <Route path="create-product/" element={<ProductForm />} />
            <Route path="bulk/" element={<BulkQRCodeGenerator />} />
            <Route path="c/:id" element={<VCardV />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
